module.exports = __webpack_public_path__ + "static/media/deleteuser.c4927428.svg";